import { Route, Routes as Switch, Navigate } from "react-router-dom";
import { Col, Row, Typography, Image } from "antd";
import Logo from "../assets/images/master_logo.png";
import Login from "../components/AuthComponents/Login";
import { useUser } from "../contexts/UserContext";

const { Title, Text } = Typography;

const AuthLayout = () => {
  const { setLoggedIn } = useUser();
  return (
    <div className="mainBgColor authMain">
      <div className="authCard">
        <Row
          style={{
            padding: "16px 20px",
          }}
        >
          <Col span={24} md={10} className="authBg">
            <Image width={180} src={Logo} preview={false} />
            <div className="authDesc">
              <Title style={{ color: "#ffffff" }} level={3}>
                Start your journey with us.
              </Title>
              <Text style={{ color: "#ffffff" }}>
                It brings together your tasks, projects, timelines, files, and
                more
              </Text>
            </div>
          </Col>
          <Col span={24} md={14}>
            <Switch>
              <Route path="/" element={<Navigate to="/login" />} />
              <Route path="*" element={<Navigate to="/login" />} />
              <Route
                path="/login"
                element={<Login setLoggedIn={setLoggedIn} />}
              />
            </Switch>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default AuthLayout;
